import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

@Injectable({ providedIn: 'root' })
export class ApiRppk15Service {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getRppk15ForTable(params: {
    siteId: number;
    startDate: string;
    endDate: string;
    vehicleTypeId?: number | null;
    entryGateId?: number | null;
  }): Observable<unknown> {
    const query: Record<string, string | number> = {
      siteId: params.siteId,
      startDate: params.startDate,
      endDate: params.endDate,
    };
    if (params.vehicleTypeId && params.vehicleTypeId > 0) {
      query['vehicleTypeId'] = params.vehicleTypeId;
    }
    if (params.entryGateId && params.entryGateId > 0) {
      query['entryGateId'] = params.entryGateId;
    }

    return this.apiMethodService.request('/FinanceReports/getRppk15ForTable', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getRppk15ForTable',
      token: this.token,
      headerOnly: false,
      params: query,
    });
  }

  getRppk15Pdf(params: {
    siteId: number;
    startDate: string;
    endDate: string;
    vehicleTypeId?: number | null;
    entryGateId?: number | null;
  }): Observable<Uint8Array> {
    let httpParams = new HttpParams()
      .set('siteId', params.siteId)
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);
    if (params.vehicleTypeId && params.vehicleTypeId > 0) {
      httpParams = httpParams.set('vehicleTypeId', params.vehicleTypeId);
    }
    if (params.entryGateId && params.entryGateId > 0) {
      httpParams = httpParams.set('entryGateId', params.entryGateId);
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
      Accept: 'application/octet-stream, application/pdf, */*',
    });

    return this.http
      .get(`${this.baseUrl}/Reports/rppk15/pdf`, {
        headers,
        params: httpParams,
        responseType: 'arraybuffer',
      })
      .pipe(map((buffer) => new Uint8Array(buffer)));
  }
}
